import { formatDateTime, type HistoryTarget } from '@pb/shared';
import { getHistory } from '../api/history';
import { channelLabel } from '../lib/text';
import { useResource } from '../lib/useResource';
import { EmptyState, ErrorState, Loading } from './States';

export function HistoryList({ target, id }: { target: HistoryTarget; id: number }) {
  const history = useResource(() => getHistory(target, id), [target, id]);
  if (history.error) return <ErrorState error={history.error} onRetry={() => void history.reload()} />;
  if (history.data === undefined) return <Loading label="Loading history…" />;
  if (history.data.length === 0) {
    return <EmptyState title="No history yet">Changes made on the web, through MCP or the CLI appear here.</EmptyState>;
  }
  return (
    <div className="card">
      <table className="table">
        <thead>
          <tr>
            <th>Time</th>
            <th>User</th>
            <th>Channel</th>
            <th>Action</th>
            <th>Summary</th>
          </tr>
        </thead>
        <tbody>
          {history.data.map((row) => (
            <tr key={row.id}>
              <td className="nowrap">{formatDateTime(row.created_at)}</td>
              <td>{row.user ?? '—'}</td>
              <td>
                <span className="badge">{channelLabel(row.channel)}</span>
              </td>
              <td>
                <code>{row.action}</code>
              </td>
              <td>{row.summary}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
